import React from "react";
import styles from "./styles/banner.css";
import {withStyles} from "@material-ui/core/styles";
import Icon from "components/icon";
import Typography from "@material-ui/core/Typography";

const Banner = ({ classes, title, subtitle, icon }) => {
    return (
        <div className={classes.banner_container}>
            {icon && <div>
                <Icon name={icon} style={{width: '30px', height: '30px'}} />
            </div>}
            <div className={classes.banner}>
                <div><Typography variant="h6">{title}</Typography></div><div>{subtitle}</div>
            </div>
        </div>
    )
}

export default withStyles(styles)(Banner);